export const contact = {
  contactName: "名字",
  favoriteContact: "收藏夹",
  contactAction: "管理",
  contactEmail: "邮箱",
  contactTransfer: "转账",
  contactDelete: "删除",
  contactDeleteMessage: "确定要删除此联系人吗?",
  contactEdit: "编辑",
  contactEditMessage: "确定要修改此联系人吗?",
  contactConfirmYes: "是",
  contactConfirmNo: "否",
  contactDeleteSuccess: "删除成功",
  contactAddSuccess: "添加成功",
  contactBackBtn: "返回",
  contactsBtnAdd: "添加",
  contactModalAdd: "添加联系人",
  contactSearch: "搜索联系人",
  contactsTableUpdating: "正在更新联系人...",
  contactLoading: "正在加载联系人信息...",
  contactError: "获取联系人信息出错。该联系人不存在。",
  contactNotFound: "未找到联系人。",
  contactAlreadyInList: "该联系人已在列表中。",
  contactAddBtn: "添加",
  contactCancelBtn: "取消",
  contactBackBtnText: "返回",
  contactSearchRequired: "请输入邮箱或昵称",
  contactSearchMinLength: "至少3个字符",
  contactSearchPlaceholder: "邮箱或昵称",
};
